import { Group } from './group';
/**
 * The GroupColor transform group data by x channel, and aggregate.
 */
export var GroupColor = function GroupColor() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return Group(Object.assign(Object.assign({}, options), {
    channels: ['color']
  }));
};
GroupColor.props = {};